<span [class]="classes()" [ngClass]="ngClass" [attr.aria-label]="ariaLabel ?? label">
  @if (icon) {
    <span class="material-icons fs-inherit">{{ icon }}</span>
  } @else {
    {{ label }}
  }
</span>
